import { DataConflictActions } from './DataConflictActions';
import { AnyAction } from 'redux';
import { IGameState } from './IGameState';
import {
    startFetching,
    failedFetchingPlayerData,
    acceptFailedFetchingConflicts,
    completeConflictResolution,
    promptConflictResolution,
} from './DataConflict/DataConflict';
import { resolveConflicts } from '@platform/State/Game/DataConflict/resolveConflicts';
import { setConflicts } from '@platform/State/Game/DataConflict/setConflicts';
import { getType } from 'typesafe-actions';

export const DataConflictReducer = (state: IGameState, action: AnyAction) => {
    switch (action.type) {
        case getType(DataConflictActions.startFetchingConflicts):
            return startFetching(state);
        case getType(DataConflictActions.setConflicts):
            return setConflicts(state, action.payload);
        case getType(DataConflictActions.resolveConflicts):
            return resolveConflicts(
                state,
                action.payload.data,
                action.payload.restoreSelection,
                action.payload.playerDataLocation
            );
        case getType(DataConflictActions.failFetchingPlayerData):
            return failedFetchingPlayerData(state);
        case getType(DataConflictActions.acceptFailFetchingPlayerData):
            return acceptFailedFetchingConflicts(state);
        case getType(DataConflictActions.completeConflictResolution):
            return completeConflictResolution(state, action.payload);
        case getType(DataConflictActions.promptConflictResolution):
            return promptConflictResolution(state);
        default:
            return state;
    }
};
